import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ScheduleConsult from 'screens/ScheduleConsult';
import { getLocations, holdAppointment } from 'redux-modules/modules/appointment';
import { login } from 'redux-modules/modules/user'
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => ({
  locations: state.appointment.locations
});

const mapDispatchToProps = (dispatch, props) => ({
  getLocations: bindActionCreators(getLocations, dispatch),
  holdAppointment: bindActionCreators(holdAppointment, dispatch),
  login: bindActionCreators(login, dispatch),
  redirectToHome: () => props.history.replace('/'),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleConsult));


// WEBPACK FOOTER //
// ./src/containers/ScheduleConsult.js